var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-dropdown-content",style:({height: _vm.dropdownHeight+'px'})},[_c('div',{ref:"navDropdownBox",staticClass:"nav-dropdown-box"},[_vm._t("navDropdown")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }